module.exports = __webpack_public_path__ + "static/img/03_img.9bb79d4.png";